import React, { useEffect, useState, useMemo } from 'react';
import styles from '../../styles/effects/StormEffect.module.scss';

interface StormEffectProps {
  isDay?: boolean;
}

const StormEffect: React.FC<StormEffectProps> = ({ isDay }) => {
  const [flash, setFlash] = useState(false);

  useEffect(() => {
    let timeoutId: number;
    const scheduleFlash = () => {
      const nextIn = 5000 + Math.random() * 10000; // 5s–15s until next flash
      timeoutId = window.setTimeout(() => {
        setFlash(true);
        setTimeout(() => {
          setFlash(false);
          scheduleFlash();
        }, 100); // flash duration
      }, nextIn);
    };
    scheduleFlash();
    return () => clearTimeout(timeoutId);
  }, []);

  const drops = useMemo(
    () =>
      Array.from({ length: 150 }).map((_, i) => {
        const left = Math.random() * 100;
        const width = 2 + Math.random() * 1; // 2px–3px
        const height = 20 + Math.random() * 10; // 20px–30px
        const duration = 0.3 + Math.random() * 0.3; // 0.3s–0.6s
        const delay = -Math.random() * duration;

        return (
          <div
            key={`drop-${i}`}
            className={styles.drop}
            style={
              {
                left: `${left}%`,
                width: `${width}px`,
                height: `${height}px`,
                animationDuration: `${duration}s`,
                animationDelay: `${delay}s`,
              } as React.CSSProperties
            }
          />
        );
      }),
    []
  );

  const clouds = useMemo(
    () =>
      Array.from({ length: 12 }).map((_, i) => {
        const top = 10 + Math.random() * 10; // 10%–20% down
        const width = 30 + Math.random() * 40; // 30%–70% wide
        const height = 40 + Math.random() * 40; // 40px–80px tall
        const opacity = 0.5 + Math.random() * 0.2; // 0.5–0.7 opacity
        const duration = 50 + Math.random() * 30; // 50s–80s across
        const delay = -Math.random() * duration;

        return (
          <div
            key={`cloud-${i}`}
            className={styles.cloud}
            style={
              {
                top: `${top}%`,
                width: `${width}%`,
                height: `${height}px`,
                opacity,
                animationDuration: `${duration}s`,
                animationDelay: `${delay}s`,
              } as React.CSSProperties
            }
          />
        );
      }),
    []
  );

  return (
    <div className={`${styles.storm} ${isDay ? styles.day : styles.night}`}>
      {clouds}
      {drops}
      <div className={styles.flash} style={{ opacity: flash ? 1 : 0 }} />
    </div>
  );
};

export default StormEffect;
